/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

import "./global.css";

// Marcador de build: muda o hash dos bundles para invalidar assets com 404 em cache no CDN.
document.documentElement.dataset.build = "2026-10-14";

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
);
